<div class="clearfix">
  <p-card styleClass="rbac-card gridview w-100">
    <app-grid-list
      [dataList]="chatUsers"
      [updateGrid]="updateGrid"
      [columns]="tableColumns"
      [totalCount]="totalcount"
      (selectedRowsData)="getSelectedData($event)">
    </app-grid-list>
  </p-card>

  <div class="clearfix text-right pt-10">
    <button class="btn btn-primary" (click)="startNewChat()">Start</button>
  </div>
</div>
